var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactivePaymentTermLoan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47842_86881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99637 7.16507C9.98339 7.16507 12.4049 6.26067 12.4049 5.14504C12.4049 4.0294 9.98339 3.125 6.99637 3.125C4.00935 3.125 1.58789 4.0294 1.58789 5.14504C1.58789 6.26067 4.00935 7.16507 6.99637 7.16507Z",
    stroke: "#4B465C",
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99637 7.16507C9.98339 7.16507 12.4049 6.26067 12.4049 5.14504C12.4049 4.0294 9.98339 3.125 6.99637 3.125C4.00935 3.125 1.58789 4.0294 1.58789 5.14504C1.58789 6.26067 4.00935 7.16507 6.99637 7.16507Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4049 5.14844V14.8576C12.4049 15.9654 9.99384 16.8777 6.99637 16.8777C3.9989 16.8777 1.58789 15.9654 1.58789 14.8576V5.14844C1.58789 6.2562 3.9989 7.16847 6.99637 7.16847C9.99384 7.16847 12.4049 6.2562 12.4049 5.14844Z",
    stroke: "#4B465C",
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4049 5.14844V14.8576C12.4049 15.9654 9.99384 16.8777 6.99637 16.8777C3.9989 16.8777 1.58789 15.9654 1.58789 14.8576V5.14844C1.58789 6.2562 3.9989 7.16847 6.99637 7.16847C9.99384 7.16847 12.4049 6.2562 12.4049 5.14844Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5741 8.39504C19.5741 9.5028 17.1631 10.4151 14.1656 10.4151C13.514 10.4151 12.9275 10.3499 12.4062 10.2847V6.50533C12.9927 6.44016 13.5792 6.375 14.1656 6.375C17.1631 6.375 19.5741 7.28728 19.5741 8.39504Z",
    stroke: "#4B465C",
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5741 8.39504C19.5741 9.5028 17.1631 10.4151 14.1656 10.4151C13.514 10.4151 12.9275 10.3499 12.4062 10.2847V6.50533C12.9927 6.44016 13.5792 6.375 14.1656 6.375C17.1631 6.375 19.5741 7.28728 19.5741 8.39504Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5735 8.39844V14.8495C19.5735 15.9573 17.1625 16.8695 14.165 16.8695C12.7966 16.8695 11.5585 16.6741 10.5811 16.3482C11.6888 15.9573 12.4056 15.436 12.4056 14.8495V10.2881C12.9921 10.3533 13.5785 10.4185 14.165 10.4185C17.1625 10.4185 19.5735 9.5062 19.5735 8.39844Z",
    stroke: "#4B465C",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5735 8.39844V14.8495C19.5735 15.9573 17.1625 16.8695 14.165 16.8695C12.7966 16.8695 11.5585 16.6741 10.5811 16.3482C11.6888 15.9573 12.4056 15.436 12.4056 14.8495V10.2881C12.9921 10.3533 13.5785 10.4185 14.165 10.4185C17.1625 10.4185 19.5735 9.5062 19.5735 8.39844Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4049 8.39844C12.4049 9.5062 9.99384 10.4185 6.99637 10.4185C3.9989 10.4185 1.58789 9.5062 1.58789 8.39844",
    stroke: "#4B465C",
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4049 8.39844C12.4049 9.5062 9.99384 10.4185 6.99637 10.4185C3.9989 10.4185 1.58789 9.5062 1.58789 8.39844",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4049 11.6484C12.4049 12.7562 9.99384 13.6685 6.99637 13.6685C3.9989 13.6685 1.58789 12.7562 1.58789 11.6484",
    stroke: "#4B465C",
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4049 11.6484C12.4049 12.7562 9.99384 13.6685 6.99637 13.6685C3.9989 13.6685 1.58789 12.7562 1.58789 11.6484",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5734 11.6484C19.5734 12.7562 17.1624 13.6685 14.1649 13.6685C13.5785 13.6685 13.0572 13.6033 12.4707 13.6033",
    stroke: "#4B465C",
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5734 11.6484C19.5734 12.7562 17.1624 13.6685 14.1649 13.6685C13.5785 13.6685 13.0572 13.6033 12.4707 13.6033",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4048 5.14504C12.4048 4.03728 9.99384 3.125 6.99637 3.125C3.9989 3.125 1.58789 4.03728 1.58789 5.14504V14.8542C1.58789 15.962 3.9989 16.8743 6.99637 16.8743C8.36478 16.8743 9.60287 16.6788 10.5803 16.353C11.5577 16.6788 12.7958 16.8743 14.1642 16.8743C17.1617 16.8743 19.5727 15.962 19.5727 14.8542V8.40316C19.5727 7.2954 17.1617 6.38312 14.1642 6.38312C13.5778 6.38312 12.9913 6.44828 12.4048 6.51345V5.14504ZM12.4048 5.14504C12.4048 5.40569 12.2745 5.60117 12.079 5.86182C12.2745 5.66633 12.4048 5.40569 12.4048 5.14504Z",
    stroke: "#4B465C",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4048 5.14504C12.4048 4.03728 9.99384 3.125 6.99637 3.125C3.9989 3.125 1.58789 4.03728 1.58789 5.14504V14.8542C1.58789 15.962 3.9989 16.8743 6.99637 16.8743C8.36478 16.8743 9.60287 16.6788 10.5803 16.353C11.5577 16.6788 12.7958 16.8743 14.1642 16.8743C17.1617 16.8743 19.5727 15.962 19.5727 14.8542V8.40316C19.5727 7.2954 17.1617 6.38312 14.1642 6.38312C13.5778 6.38312 12.9913 6.44828 12.4048 6.51345V5.14504ZM12.4048 5.14504C12.4048 5.40569 12.2745 5.60117 12.079 5.86182C12.2745 5.66633 12.4048 5.40569 12.4048 5.14504Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5734 11.6484C19.5734 12.7562 17.1624 13.6685 14.1649 13.6685C13.5785 13.6685 13.0572 13.6033 12.4707 13.6033",
    stroke: "#4B465C",
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5734 11.6484C19.5734 12.7562 17.1624 13.6685 14.1649 13.6685C13.5785 13.6685 13.0572 13.6033 12.4707 13.6033",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.977436,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47842_86881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivePaymentTermLoan);
export default __webpack_public_path__ + "static/media/inactive-payment-term-loan.0b2e3128c55abc9aa0e22ba850abd4db.svg";
export { ForwardRef as ReactComponent };